export default __webpack_public_path__ + "static/media/calendar.e0a2f76b.jpg";